export default __webpack_public_path__ + "static/media/setting.495f5963.svg";